import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SunMark } from './Nav';
import './PageHeader.css';

const Hamburger = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" aria-hidden>
    <path d="M4 7h16M4 12h16M4 17h12" />
  </svg>
);

const BackArrow = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M15 5l-7 7 7 7" />
  </svg>
);

/**
 * PageHeader
 * - Default mode: sun (left) · date · hamburger (right). Hamburger opens Profile.
 * - back: when true, the left button becomes a back arrow that goes back in
 *   history, and the right button is hidden (used on Profile / sub-pages).
 * - title: optional short label for back-mode headers (e.g. "Settings").
 */
export default function PageHeader({ user, dateLabel, onMenu, back = false, title }) {
  const navigate = useNavigate();
  const today = dateLabel || (() => {
    const d = new Date();
    return d.toLocaleDateString('en-US', { month: 'long', day: 'numeric', weekday: 'long' });
  })();

  if (back) {
    return (
      <div className="hx-page-header is-back">
        <button
          className="icon-btn"
          onClick={() => {
            try { window.history.length > 1 ? navigate(-1) : navigate('/app/today'); }
            catch { navigate('/app/today'); }
          }}
          aria-label="Back"
        >
          <BackArrow />
        </button>
        <div className="hx-page-header-date">{title || today}</div>
        <span className="hx-page-header-spacer" aria-hidden />
      </div>
    );
  }

  return (
    <div className="hx-page-header">
      <button className="icon-btn" onClick={() => navigate('/app/today')} aria-label="Home">
        <SunMark />
      </button>
      <div className="hx-page-header-date">{today}</div>
      <button className="icon-btn" onClick={onMenu || (() => navigate('/app/profile'))} aria-label="Menu">
        <Hamburger />
      </button>
    </div>
  );
}
